var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.status.color,"text-color":"white"}},[_vm._v(" "+_vm._s(_vm.status.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }